
import React, { useEffect, useState } from 'react';
import RadioInput from '../../../../Shared/RadioInput/RadioInput';

const RouteDetails = (props) => {

    const route = (item, index) => {
        const title = item.cmsData?.selfCare?.title ? item.cmsData?.selfCare?.title : item.localizedName;
        const isSelected = props.selectedPackageRoute?.name == item.name;
        const label = () => {
            return (<div className={`package-route ${isSelected ? 'selected' : ''}`} >
                <div className='route-name'>{title}</div>
                <div className='price-wrapper'>
                    <div className='price'>{item.price}<span className='nis'>₪</span></div>
                    {item.duration.amount == '0' ?
                        <div className='time-period'>לחודש</div> :
                        <div className='time-period'>חד פעמי</div>
                    }
                </div>
            </div>)
        }
        return (
            <RadioInput
                key={index}
                checked={isSelected}
                id={item.name}
                name='package route'
                value={item.name}
                label={label()}
                onChange={() => { props.onSelectedPackage(item) }}
            />
        )
    }

    return (<div className='route-details-wrapper'>
        <div className='title'>בחרו את המסלול שמתאים לכם</div>
        {/* {route(props.selectedPackage, 0)} */}
        {props.selectedPackage?.vasList?.map((item, index) => {
            { return (route(item, index + 1)) }
        })}
    </div>);
}
export default RouteDetails;
